'use client';

interface ReadinessRingProps {
  score: number;
  size?: number;
}

const ReadinessRing = ({ score, size = 32 }: ReadinessRingProps) => {
  const clampedScore = Math.max(0, Math.min(100, Math.round(score ?? 0)));

  const colorHex =
    clampedScore >= 80 ? '#16a34a' :
    clampedScore >= 60 ? '#F5A623': '#dc2626';

  const circumference = 2 * Math.PI * 13;
  const dashOffset = circumference * (1 - clampedScore / 100);

  return (
    <div
      className="relative flex items-center justify-center flex-shrink-0"
      style={{ width: size, height: size }}
      title={`Readiness: ${clampedScore}/100`}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        className="flex-shrink-0"
        style={{ transform: 'rotate(-90deg)' }}
        aria-hidden="true"
      >
        <circle cx="16" cy="16" r="13" stroke="#E5E7EB" strokeWidth="3" fill="none" />
        <circle
          cx="16"
          cy="16"
          r="13"
          stroke={colorHex}
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          style={{ transition: 'stroke-dashoffset 0.4s ease' }}
        />
      </svg>
      <span
        className="absolute text-[9px] font-bold"
        style={{ color: colorHex, lineHeight: 1 }}
      >
        {clampedScore}
      </span>
    </div>
  );
};

export default ReadinessRing;
